export default "__VITE_ASSET__Cjpm4nakhIL_1e0a80RZ_Q__"